import once from 'lodash/once'

import { dataLayerPush } from 'client/contexts/Tracking'

interface Params {
  eventName: string
  onlyOnce?: boolean
}

export const sendEvent = (eventName: string) => () =>
  dataLayerPush([
    {
      event: eventName,
    },
  ])

const useGtmEvent = ({ eventName, onlyOnce = false }: Params) => {
  const notify = onlyOnce ? once(sendEvent(eventName)) : sendEvent(eventName)

  return {
    notify,
  }
}

export default useGtmEvent
